import tw from "twin.macro";
export const PrimaryButton = tw.button`
  px-8 py-3 font-bold rounded bg-primary-500 text-gray-100 
  focus:shadow-outline focus:outline-none 
  hover:bg-primary-500 hover:text-gray-100 
  active:bg-primary-500 active:text-gray-100
`;
